const Setting = {
  path: "",
  name: "",
  redirect: "/setting",
  component: {
    render(c) {
      return c("router-view");
      P;
    },
  },
  children: [
    {
      path: "/setting-serial",
      redirect: "/setting-serial",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Setting",
      meta: {
        requiresAuth: true,
        activeUrl: "/setting-serial",

        lv: 2,
      },
      children: [
        {
          path: "/setting-serial",
          name: "",
          component: () => import("@/views/pages/setting/SettingSerial"),
          meta: {
            activeUrl: "/setting-serial",
            isChildren: true,
            requiresAuth: true,

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Setting Detail",
          component: () => import("@/views/pages/setting/SettingSerial/detail"),
          meta: {
            activeUrl: "/setting-serial",
            isChildren: true,
            requiresAuth: true,

            lv: 3,
          },
        },
      ],
    },
    {
      path: "/setting-non-serial",
      redirect: "/setting-non-serial",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Setting",
      meta: {
        requiresAuth: true,
        activeUrl: "/setting-non-serial",

        lv: 2,
      },
      children: [
        {
          path: "/setting-non-serial",
          name: "",
          component: () => import("@/views/pages/setting/SettingNonSerial"),
          meta: {
            activeUrl: "/setting-non-serial",
            isChildren: true,
            requiresAuth: true,

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Setting Detail",
          component: () => import("@/views/pages/setting/SettingNonSerial/detail"),
          meta: {
            activeUrl: "/setting-non-serial",
            isChildren: true,
            requiresAuth: true,

            lv: 3,
          },
        },
      ],
    },
    {
      path: "/setting-cover-sheet",
      redirect: "/setting-cover-sheet",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Setting",
      meta: {
        requiresAuth: true,
        activeUrl: "/setting-cover-sheet",

        lv: 2,
      },
      children: [
        {
          path: "/setting-cover-sheet",
          name: "",
          component: () => import("@/views/pages/setting/SettingCoverSheet"),
          meta: {
            activeUrl: "/setting-cover-sheet",
            isChildren: true,
            requiresAuth: true,

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Setting Detail",
          component: () => import("@/views/pages/setting/SettingCoverSheet/detail"),
          meta: {
            activeUrl: "/setting-cover-sheet",
            isChildren: true,
            requiresAuth: true,

            lv: 3,
          },
        },
      ],
    },
  ],
};
export default Setting;
